import { Pipe, type PipeTransform } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Pipe({
	name: 'getFormGroup',
	standalone: true
})
export class GetFormGroupPipe implements PipeTransform {
	transform(formGroup: FormGroup, controlName: string): FormGroup | FormArray {
		const control = formGroup.get(controlName);
		if (control instanceof FormGroup || control instanceof FormArray) {
			return control;
		}
		throw new Error('Control is not a FormGroup or FormArray');
	}
}
